import AuthContext from './auth.context';

export default AuthContext;
